import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path d="M0 3h20v2H0zm0 6h20v2H0zm0 6h20v2H0z" fill="currentColor" />
  </svg>
);
